// The rounded corners belong to the cloud's card on the page; a downloaded or presented cloud is a
// plain rectangle. Takes an export clone of the cloud's <svg>, never the mounted one, and hands it back.
export const removeCloudCorners = svg => {
  for (const node of svg?.children || []) {
    if ('rect' !== node.tagName.toLowerCase()) continue

    node.removeAttribute('rx')
    node.removeAttribute('ry')
  }

  return svg
}
